
import './buttons.css'

export default function OrangeButton({ text, onClick, disabled, className}) {
   return (
         <button onClick={onClick} disabled={disabled} className={` ${className} oranage-btn`} title={text}>
            {text}
         </button>
   );
}